import { ValueFormatterParams, ValueGetterFunc } from 'ag-grid-community';
import { EM_DASH } from '../../Base.constants';
import { IssuerListItemDto } from '../../services/dtos/issuer/issuerList.dto';
import { DATE_FORMATS, formatDate } from '../../utils/dateUtils';

export const getCompanyPageLink = (tagId: string): string => {
  const [tagType, tagValue] = tagId.split('/');
  return tagType === 'company' ? `/companies/${tagValue}` : `/municipals/${tagValue}`;
};

export const impliedValueGetter: (tagType: string) => ValueGetterFunc<IssuerListItemDto> = (tagType) => (params) =>
  params.data?.implied
    .filter(({ type }) => tagType === type)
    .map((impliedTag) => impliedTag.displayName)
    .join(', ');

export const dateFormatter = (params: ValueFormatterParams<IssuerListItemDto>): string =>
  formatDate(params.value, DATE_FORMATS.MONTH_ABBR_DATE, EM_DASH);
